import { Alert } from "react-bootstrap";

export default function SuccessAlert({ msg, onClose }) {
  return (
    <Alert variant="success" dismissible onClose={onClose}>
      {msg || "Operação bem-sucedida."}
    </Alert>
  );
}
